import styled from 'styled-components';

export const Form = styled.form`
  padding: 0 16px;

  & input[type='file'] {
    padding: 15px;
  }
  & input[type='file']::-webkit-file-upload-button {
    /* display: none; */
    background: none;
    outline: none;
    border: 1px solid black;
    border-radius: 8px;
  }
`;
